import { render, staticRenderFns } from "./CategoryThumbnail.vue?vue&type=template&id=79eadb26&scoped=true&"
import script from "./CategoryThumbnail.vue?vue&type=script&lang=js&"
export * from "./CategoryThumbnail.vue?vue&type=script&lang=js&"
import style0 from "@/styles/components/CategoryThumbnail/CategoryThumbnail.less?vue&type=style&index=0&id=79eadb26&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79eadb26",
  null
  
)

export default component.exports